import { Box, Typography } from '@mui/material';
import { SafeLinkWithFallback } from '../SafeLinkWithFallback';
import { Rating } from './components/Rating';
import { RatingTooltip, type RatingTooltipProps } from './components/RatingToolTip';

type StarRatingAboveTooltipBelowLayoutProps = {
  reviewLink?: string | null;
  starRating?: number;
  starRatingTooltip?: string;
  hideNumber?: boolean;
  align?: 'start' | 'center' | 'end';
  tooltipProps?: Omit<RatingTooltipProps, 'starRatingTooltip'>;
  hideRatingLink?: boolean;
};

export const StarRatingAboveTooltipBelowLayout = ({
  reviewLink,
  starRating,
  starRatingTooltip,
  hideNumber = false,
  hideRatingLink = false,
  align = 'start',
  tooltipProps = {
    tooltipSize: '18px',
    tooltipColor: 'neutral.dark',
    paddingX: '1.5rem',
    paddingY: '12px',
  },
}: StarRatingAboveTooltipBelowLayoutProps) => {
  if (!starRating) return 'Not yet rated';
  return (
    <Box
      data-testid="rating-component"
      sx={{ display: 'flex', alignItems: align, flexDirection: 'column' }}
    >
      {!hideRatingLink && (
        <Box>
          <Box sx={{ display: 'inline-block' }}>
            <Typography
              variant="text"
              sx={{
                whiteSpace: 'nowrap',
                fontSize: { xs: 13, md: 16 },
              }}
            >
              <SafeLinkWithFallback href={reviewLink}>NerdWallet rating </SafeLinkWithFallback>
              {starRatingTooltip && (
                <RatingTooltip starRatingTooltip={starRatingTooltip} {...tooltipProps} />
              )}
            </Typography>
          </Box>
        </Box>
      )}
      <Box sx={{ display: 'flex', gap: '0.25rem' }}>
        <Rating
          value={starRating}
          gap="5px"
          additionalStyles={{
            '--star-rating-size': { xs: '15px', md: '16px' },
            marginTop: '2px',
            marginRight: 2,
          }}
        />
        {!hideNumber && starRating && starRating !== 0 && (
          <Typography
            sx={{
              mr: 1,
              display: 'inline-block',
            }}
          >
            {starRating.toFixed(1)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
